import { UserDataType } from "../Data/UserData";

const stations = [
  {
    "stationId": 1,
    "stationName": "Southport",
    "position": [
      900,
      150
    ],
    "shape": "cicle",
    "lineIds": [
      1
    ]
  },
  {
    "stationId": 2,
    "stationName": "Birkdale",
    "position": [
      900,
      210
    ],
    "shape": "cicle",
    "lineIds": [
      1
    ]
  },
  {
    "stationId": 3,
    "stationName": "Hillside",
    "position": [
      900,
      270
    ],
    "shape": "cicle",
    "lineIds": [
      1
    ]
  },
  {
    "stationId": 4,
    "stationName": "Ainsdale",
    "position": [
      900,
      330
    ],
    "shape": "cicle",
    "lineIds": [
      1
    ]
  },
  {
    "stationId": 5,
    "stationName": "Freshfield",
    "position": [
      900,
      390
    ],
    "shape": "cicle",
    "lineIds": [
      1
    ]
  },
  {
    "stationId": 6,
    "stationName": "Formby",
    "position": [
      900,
      450
    ],
    "shape": "cicle",
    "lineIds": [
      1
    ]
  },
  {
    "stationId": 7,
    "stationName": "Hightown",
    "position": [
      900,
      510
    ],
    "shape": "cicle",
    "lineIds": [
      1
    ]
  },
  {
    "stationId": 8,
    "stationName": "Hall Road",
    "position": [
      900,
      570
    ],
    "shape": "cicle",
    "lineIds": [
      1
    ]
  },
  {
    "stationId": 9,
    "stationName": "Blundellsands and Crosby",
    "position": [
      900,
      630
    ],
    "shape": "cicle",
    "lineIds": [
      1
    ]
  },
  {
    "stationId": 10,
    "stationName": "Waterloo",
    "position": [
      900,
      690
    ],
    "shape": "cicle",
    "lineIds": [
      1
    ]
  },
  {
    "stationId": 11,
    "stationName": "Seaforth & Litherland",
    "position": [
      900,
      750
    ],
    "shape": "cicle",
    "lineIds": [
      1
    ]
  },
  {
    "stationId": 12,
    "stationName": "Bootle New Strand",
    "position": [
      900,
      810
    ],
    "shape": "cicle",
    "lineIds": [
      1
    ]
  },
  {
    "stationId": 13,
    "stationName": "Bootle Oriel Road",
    "position": [
      900,
      870
    ],
    "shape": "cicle",
    "lineIds": [
      1
    ]
  },
  {
    "stationId": 14,
    "stationName": "Bank Hall",
    "position": [
      900,
      930
    ],
    "shape": "cicle",
    "lineIds": [
      1
    ]
  },
  {
    "stationId": 15,
    "stationName": "Kirkdale",
    "position": [
      900,
      990
    ],
    "shape": "cicle",
    "lineIds": [
      1,
      2,
      3
    ]
  },
  {
    "stationId": 16,
    "stationName": "Sandhills",
    "position": [
      900,
      1050
    ],
    "shape": "cicle",
    "lineIds": [
      1
    ]
  },
  {
    "stationId": 17,
    "stationName": "Moorfields",
    "position": [
      900,
      1110
    ],
    "shape": "cicle",
    "lineIds": [
      1,
      4,
      5,
      6,
      7
    ]
  },
  {
    "stationId": 18,
    "stationName": "Liverpool Central",
    "position": [
      900,
      1170
    ],
    "shape": "cicle",
    "lineIds": [
      1,
      4,
      5,
      6,
      7
    ]
  },
  {
    "stationId": 19,
    "stationName": "Brunswick",
    "position": [
      900,
      1230
    ],
    "shape": "cicle",
    "lineIds": [
      1
    ]
  },
  {
    "stationId": 20,
    "stationName": "St. Michaels",
    "position": [
      900,
      1290
    ],
    "shape": "cicle",
    "lineIds": [
      1
    ]
  },
  {
    "stationId": 21,
    "stationName": "Aigburth",
    "position": [
      960,
      1350
    ],
    "shape": "cicle",
    "lineIds": [
      1
    ]
  },
  {
    "stationId": 22,
    "stationName": "Cressington",
    "position": [
      1020,
      1350
    ],
    "shape": "cicle",
    "lineIds": [
      1
    ]
  },
  {
    "stationId": 23,
    "stationName": "Liverpool South Parkway",
    "position": [
      1080,
      1350
    ],
    "shape": "cicle",
    "lineIds": [
      1
    ]
  },
  {
    "stationId": 24,
    "stationName": "Hunts Cross",
    "position": [
      1140,
      1350
    ],
    "shape": "cicle",
    "lineIds": [
      1
    ]
  },
  {
    "stationId": 25,
    "stationName": "Walton",
    "position": [
      960,
      930
    ],
    "shape": "cicle",
    "lineIds": [
      2
    ]
  },
  {
    "stationId": 26,
    "stationName": "Orrell Park",
    "position": [
      1020,
      870
    ],
    "shape": "cicle",
    "lineIds": [
      2
    ]
  },
  {
    "stationId": 27,
    "stationName": "Aintree",
    "position": [
      1080,
      810
    ],
    "shape": "cicle",
    "lineIds": [
      2
    ]
  },
  {
    "stationId": 28,
    "stationName": "Old Roan",
    "position": [
      1140,
      750
    ],
    "shape": "cicle",
    "lineIds": [
      2
    ]
  },
  {
    "stationId": 29,
    "stationName": "Maghull",
    "position": [
      1200,
      690
    ],
    "shape": "cicle",
    "lineIds": [
      2
    ]
  },
  {
    "stationId": 30,
    "stationName": "Maghull North",
    "position": [
      1260,
      630
    ],
    "shape": "cicle",
    "lineIds": [
      2
    ]
  },
  {
    "stationId": 31,
    "stationName": "Town Green",
    "position": [
      1320,
      570
    ],
    "shape": "cicle",
    "lineIds": [
      2
    ]
  },
  {
    "stationId": 32,
    "stationName": "Aughton Park",
    "position": [
      1380,
      510
    ],
    "shape": "cicle",
    "lineIds": [
      2
    ]
  },
  {
    "stationId": 33,
    "stationName": "Ormskirk",
    "position": [
      1440,
      450
    ],
    "shape": "cicle",
    "lineIds": [
      2
    ]
  },
  {
    "stationId": 34,
    "stationName": "Rice Lane",
    "position": [
      960,
      990
    ],
    "shape": "cicle",
    "lineIds": [
      3
    ]
  },
  {
    "stationId": 35,
    "stationName": "Fazakerley",
    "position": [
      1020,
      990
    ],
    "shape": "cicle",
    "lineIds": [
      3
    ]
  },
  {
    "stationId": 36,
    "stationName": "Kirkby",
    "position": [
      1080,
      990
    ],
    "shape": "cicle",
    "lineIds": [
      3
    ]
  },
  {
    "stationId": 37,
    "stationName": "Headbolt Lane",
    "position": [
      1140,
      990
    ],
    "shape": "cicle",
    "lineIds": [
      3
    ]
  },
  {
    "stationId": 38,
    "stationName": "James Street",
    "position": [
      840,
      1110
    ],
    "shape": "cicle",
    "lineIds": [
      4,
      5,
      6,
      7
    ]
  },
  {
    "stationId": 39,
    "stationName": "Lime Street",
    "position": [
      960,
      1170
    ],
    "shape": "cicle",
    "lineIds": [
      4,
      5,
      6,
      7
    ]
  },
  {
    "stationId": 40,
    "stationName": "Hamilton Square",
    "position": [
      780,
      1110
    ],
    "shape": "cicle",
    "lineIds": [
      4,
      5,
      6,
      7
    ]
  },
  {
    "stationId": 41,
    "stationName": "Conway Park",
    "position": [
      720,
      1050
    ],
    "shape": "cicle",
    "lineIds": [
      4,
      5
    ]
  },
  {
    "stationId": 42,
    "stationName": "Birkenhead Park",
    "position": [
      660,
      990
    ],
    "shape": "cicle",
    "lineIds": [
      4,
      5
    ]
  },
  {
    "stationId": 43,
    "stationName": "Birkenhead North",
    "position": [
      660,
      930
    ],
    "shape": "cicle",
    "lineIds": [
      4,
      5
    ]
  },
  {
    "stationId": 44,
    "stationName": "Bidston",
    "position": [
      660,
      870
    ],
    "shape": "cicle",
    "lineIds": [
      4,
      5
    ]
  },
  {
    "stationId": 45,
    "stationName": "Leasowe",
    "position": [
      600,
      810
    ],
    "shape": "cicle",
    "lineIds": [
      4
    ]
  },
  {
    "stationId": 46,
    "stationName": "Moreton",
    "position": [
      540,
      750
    ],
    "shape": "cicle",
    "lineIds": [
      4
    ]
  },
  {
    "stationId": 47,
    "stationName": "Meols",
    "position": [
      480,
      750
    ],
    "shape": "cicle",
    "lineIds": [
      4
    ]
  },
  {
    "stationId": 48,
    "stationName": "Manor Road",
    "position": [
      420,
      810
    ],
    "shape": "cicle",
    "lineIds": [
      4
    ]
  },
  {
    "stationId": 49,
    "stationName": "Hoylake",
    "position": [
      360,
      870
    ],
    "shape": "cicle",
    "lineIds": [
      4
    ]
  },
  {
    "stationId": 50,
    "stationName": "West Kirby",
    "position": [
      300,
      930
    ],
    "shape": "cicle",
    "lineIds": [
      4
    ]
  },
  {
    "stationId": 51,
    "stationName": "Wallasey Village",
    "position": [
      720,
      870
    ],
    "shape": "cicle",
    "lineIds": [
      5
    ]
  },
  {
    "stationId": 52,
    "stationName": "Wallasey Grove Road",
    "position": [
      720,
      810
    ],
    "shape": "cicle",
    "lineIds": [
      5
    ]
  },
  {
    "stationId": 53,
    "stationName": "New Brighton",
    "position": [
      720,
      750
    ],
    "shape": "cicle",
    "lineIds": [
      5
    ]
  },
  {
    "stationId": 54,
    "stationName": "Birkenhead Central",
    "position": [
      780,
      1170
    ],
    "shape": "cicle",
    "lineIds": [
      6,
      7
    ]
  },
  {
    "stationId": 55,
    "stationName": "Green Lane",
    "position": [
      780,
      1230
    ],
    "shape": "cicle",
    "lineIds": [
      6,
      7
    ]
  },
  {
    "stationId": 56,
    "stationName": "Rock Ferry",
    "position": [
      780,
      1290
    ],
    "shape": "cicle",
    "lineIds": [
      6,
      7
    ]
  },
  {
    "stationId": 57,
    "stationName": "Bebington",
    "position": [
      840,
      1350
    ],
    "shape": "cicle",
    "lineIds": [
      6,
      7
    ]
  },
  {
    "stationId": 58,
    "stationName": "Port Sunlight",
    "position": [
      900,
      1410
    ],
    "shape": "cicle",
    "lineIds": [
      6,
      7
    ]
  },
  {
    "stationId": 59,
    "stationName": "Spital",
    "position": [
      960,
      1470
    ],
    "shape": "cicle",
    "lineIds": [
      6,
      7
    ]
  },
  {
    "stationId": 60,
    "stationName": "Bromborough Rake",
    "position": [
      1020,
      1530
    ],
    "shape": "cicle",
    "lineIds": [
      6,
      7
    ]
  },
  {
    "stationId": 61,
    "stationName": "Bromborough",
    "position": [
      1080,
      1590
    ],
    "shape": "cicle",
    "lineIds": [
      6,
      7
    ]
  },
  {
    "stationId": 62,
    "stationName": "Eastham Rake",
    "position": [
      1140,
      1650
    ],
    "shape": "cicle",
    "lineIds": [
      6,
      7
    ]
  },
  {
    "stationId": 63,
    "stationName": "Hooton",
    "position": [
      1200,
      1710
    ],
    "shape": "cicle",
    "lineIds": [
      6,
      7
    ]
  },
  {
    "stationId": 64,
    "stationName": "Capenhurst",
    "position": [
      1200,
      1770
    ],
    "shape": "cicle",
    "lineIds": [
      6
    ]
  },
  {
    "stationId": 65,
    "stationName": "Bache",
    "position": [
      1200,
      1830
    ],
    "shape": "cicle",
    "lineIds": [
      6
    ]
  },
  {
    "stationId": 66,
    "stationName": "Chester",
    "position": [
      1200,
      1890
    ],
    "shape": "cicle",
    "lineIds": [
      6
    ]
  },
  {
    "stationId": 67,
    "stationName": "Little Sutton",
    "position": [
      1260,
      1770
    ],
    "shape": "cicle",
    "lineIds": [
      7
    ]
  },
  {
    "stationId": 68,
    "stationName": "Overpool",
    "position": [
      1320,
      1830
    ],
    "shape": "cicle",
    "lineIds": [
      7
    ]
  },
  {
    "stationId": 69,
    "stationName": "Ellesmere Port",
    "position": [
      1380,
      1830
    ],
    "shape": "cicle",
    "lineIds": [
      7
    ]
  }
];

const lines = [
  {
    "lineId": 1,
    "lineName": "Northern Line",
    "color": "#0072CE",
    "stationIds": [
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24
    ],
    "sign": "N",
    "order": 1,
    "bendFirst": [
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true
    ]
  },
  {
    "lineId": 2,
    "lineName": "Northern Line (Ormskirk Branch)",
    "color": "#0072CE",
    "stationIds": [
      15,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33
    ],
    "sign": "N",
    "order": 2,
    "bendFirst": [
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true
    ]
  },
  {
    "lineId": 3,
    "lineName": "Northern Line (Kirkby Branch)",
    "color": "#0072CE",
    "stationIds": [
      15,
      34,
      35,
      36,
      37
    ],
    "sign": "N",
    "order": 3,
    "bendFirst": [
      true,
      true,
      true,
      true,
      true
    ]
  },
  {
    "lineId": 4,
    "lineName": "Wirral Line (West Kirby)",
    "color": "#008A52",
    "stationIds": [
      50,
      49,
      48,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      40,
      38,
      17,
      39,
      18,
      38
    ],
    "sign": "W",
    "order": 4,
    "bendFirst": [
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true
    ]
  },
  {
    "lineId": 5,
    "lineName": "Wirral Line (New Brighton)",
    "color": "#008A52",
    "stationIds": [
      53,
      52,
      51,
      44,
      43,
      42,
      41,
      40,
      38,
      17,
      39,
      18,
      38
    ],
    "sign": "W",
    "order": 5,
    "bendFirst": [
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true
    ]
  },
  {
    "lineId": 6,
    "lineName": "Wirral Line (Chester)",
    "color": "#008A52",
    "stationIds": [
      66,
      65,
      64,
      63,
      62,
      61,
      60,
      59,
      58,
      57,
      56,
      55,
      54,
      40,
      38,
      17,
      39,
      18,
      38
    ],
    "sign": "W",
    "order": 6,
    "bendFirst": [
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true
    ]
  },
  {
    "lineId": 7,
    "lineName": "Wirral Line (Ellesmere Port)",
    "color": "#008A52",
    "stationIds": [
      69,
      68,
      67,
      63,
      62,
      61,
      60,
      59,
      58,
      57,
      56,
      55,
      54,
      40,
      38,
      17,
      39,
      18,
      38
    ],
    "sign": "W",
    "order": 7,
    "bendFirst": [
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true
    ]
  }
];

export const liverpoolMerseyrail: UserDataType = {
  stations: stations.reduce((map, cur) => {
    map.set(cur.stationId, cur);
    return map;
  }, new Map()),
  lines: lines.reduce((map, cur) => {
    map.set(cur.lineId, cur);
    return map;
  }, new Map()),
  title: "Liverpool Merseyrail",
  backgroundColor: "#f8f8f6",
};
